import HomeIcon from "@mui/icons-material/Home";
import { Box, IconButton, Stack } from "@mui/material";

import { Banner } from "components/Banner";
import { LapsedSubscriptionBanner } from "components/LapsedSubscriptionBanner";
import { RootSideBar } from "components/RootSideBar";
import { BG_ICON_COLOR } from "constants/index";
import { useDisclosure } from "hooks";
import { useIsMobile } from "hooks/useIsMobile";

import { MAIN_CONTENT_ELEMENT_ID } from "./constants";
import { NavigationBar } from "../components/NavigationBar";

interface Props {
  content: React.ReactNode;
  hideNav?: boolean;
}

export function AppLayout(props: Props) {
  const { content, hideNav = false } = props;

  const { isOpen, onOpen, onClose } = useDisclosure(false);

  // TODO: Make this better, this is hacky.
  const isMobile = useIsMobile({ maxWidth: 750 });

  const navBarIcon = (
    <Box>
      <IconButton onClick={onOpen}>
        <HomeIcon sx={{ color: "white" }} fontSize="large" />
      </IconButton>
    </Box>
  );

  // The top-of-app messaging surfaces and the page itself, shared by both
  // layouts so a new banner only has to be placed once.
  const body = (
    <>
      <Banner
        isMobile={isMobile}
        openNavBarIcon={hideNav ? null : navBarIcon}
      />
      <LapsedSubscriptionBanner />
      {content}
    </>
  );

  if (hideNav) {
    return (
      <Box
        id={MAIN_CONTENT_ELEMENT_ID}
        sx={{ height: "100vh", overflowY: "auto" }}
      >
        <Stack>{body}</Stack>
      </Box>
    );
  }

  return (
    <Box display="flex" sx={{ flexFlow: "column", height: "100vh" }}>
      <Box
        display="flex"
        sx={{
          backgroundColor: BG_ICON_COLOR,
          height: "100%",
          padding: ".5rem .5rem .5rem 1rem",
          overflow: "hidden",
        }}
      >
        {isMobile ? (
          <RootSideBar
            isOpen={isOpen}
            onClose={onClose}
            content={<NavigationBar />}
          />
        ) : (
          <NavigationBar />
        )}
        <Box
          id={MAIN_CONTENT_ELEMENT_ID}
          display="flex"
          sx={{
            flexFlow: "column",
            width: "100%",
            overflowY: "scroll",
          }}
        >
          {body}
        </Box>
      </Box>
    </Box>
  );
}
